import { createSlice } from "@reduxjs/toolkit";
import SonucIzlemeMuracaatListeRequest from "src/models/SonucIzleme/SonucIzlemeMuracaatListeRequest";
import SonucIzlemeRaporIndirRequest from "src/models/SonucIzleme/SonucIzlemeRaporIndirRequest";
import VwSonucizlememuracaatDTO from "src/models/SonucIzleme/VwSonucizlememuracaatDTO";
import VwSiPatolojidetaylistDTO from "src/models/PatolojiModul/VwSiPatolojidetaylistDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { SonucIzlemeApi } from "src/services/SonucIzleme/SonucIzlemeApi";
import { helper } from "src/utils/helper";

interface ISonucIzleme {
    searchModel: SonucIzlemeMuracaatListeRequest;
    searchHandler: boolean;
    selectionModel: Array<number>;
    raporIds: Array<SonucIzlemeRaporIndirRequest>;
    data: Array<VwSonucizlememuracaatDTO>;
    activeRow: VwSonucizlememuracaatDTO;
    patolojiDetay: Array<VwSiPatolojidetaylistDTO>;
};

export const SonucIzlemeSlice = createSlice<ISonucIzleme, MapReducerPayloads<ISonucIzleme, {
    setSearchModel: SonucIzlemeMuracaatListeRequest;
    setSearchHandler?: boolean;
    setSelectionModel: Array<number>;
    setRaporIds: Array<SonucIzlemeRaporIndirRequest>;
    setData: Array<VwSonucizlememuracaatDTO>;
    setActiveRow: VwSonucizlememuracaatDTO;
    setPatolojiDetay: Array<VwSiPatolojidetaylistDTO>;
}>>({
    name: "sonucIzleme",
    initialState: {
        searchModel: new SonucIzlemeMuracaatListeRequest(),
        searchHandler: true,
        selectionModel: [],
        raporIds: new Array<SonucIzlemeRaporIndirRequest>(),
        data: new Array<VwSonucizlememuracaatDTO>(),
        activeRow: new VwSonucizlememuracaatDTO(),
        patolojiDetay: new Array<VwSiPatolojidetaylistDTO>(),
    },
    reducers: {
        /**
         * Sonuc izleme arama kriterlerini set eder
         * @param state 
         * @param action 
        */
        setSearchModel: (state, action) => {
            state.searchModel = action.payload;
        },
        /**
         * Sonuc izleme müracaat listesi arama handler'ını set eder
         * @param state 
         * @param action 
        */
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload;
        },
        /**
         * DataGrid'de seçilen satırları set eder
         * @param state 
         * @param action 
        */
        setSelectionModel: (state, action) => {
            state.selectionModel = action.payload;
        },
        /**
         * Raporların id'lerini set eder
         * @param state 
         * @param action 
        */
        setRaporIds: (state, action) => {
            state.raporIds = action.payload;
        },
        /**
         * DataGrid'de kullanılacak veriyi set eder
         * @param state 
         * @param action 
        */
        setData: (state, action) => {
            state.data = action.payload;
        },
        /**
         * Aktif satırı set eder
         * @param state 
         * @param action 
        */
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        /**
         * Patoloji detay verilerini set eder
         * @param state 
         * @param action 
        */
        setPatolojiDetay: (state, action) => {
            state.patolojiDetay = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(SonucIzlemeApi.endpoints.SonucIzlemeMuracaatListesi.matchFulfilled, (state, action) => {
            state.data = helper.getUniqueItemsByProperty(action.payload, "muracaatId");
        });
    },
});